// Scripts librairies
import { docReady } from './js/libs/utils'

// Charge la base commune
require('./common.js')

docReady(function () {
//  console.log('Offers template')

  // gestion des filtres depuis la navbar
  const $mn = document.getElementById('sub-nav')
  const $h = document.getElementById('header')
  const openHeader = function () {
    const stickyEl = $mn.closest('.sticky-top')
    if ($h.querySelector('.navbar-collapse').classList.contains('show')) {
      stickyEl.style.zIndex = '999'
    } else {
      stickyEl.style.zIndex = '1020'
    }
  }
  $h.querySelector('.navbar-toggler[data-trigger]').addEventListener('click', openHeader)
  $h.querySelector('.navbar-close').addEventListener('click', openHeader)
  if ($mn && $mn.querySelector('.navbar-toggler[data-trigger]')) {
    const openSubnav = function () {
      const stickyEl = $mn.closest('.sticky-top')
      if ($mn.querySelector('.navbar-collapse').classList.contains('show')) {
        stickyEl.style.zIndex = '1020'
      } else {
        stickyEl.style.zIndex = '999'
      }
    }
    $mn.querySelector('.navbar-toggler[data-trigger]').addEventListener('click', openSubnav)
    $mn.querySelector('.navbar-close').addEventListener('click', openSubnav)
  }

  // auto-anchor
  const target = document.getElementById('detail')
  if (target) {
    setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth' })
    }, 500)
  }
})
